(() => {
  const hero = document.querySelector('[data-hidream-hero]');
  if (!hero) return;

  const homeNav = hero.querySelector('.hd-home-nav');
  const standardHeader = document.querySelector('.section-header');
  const heroVideo = hero.querySelector('.hd-hero__video');
  let videoRecoveryAttempted = false;
  let heroHasPlayed = false;

  const showVideoFallback = () => {
    hero.classList.remove('hd-hero--video-playing');
    hero.classList.add('hd-hero--video-fallback');
  };

  const markVideoPlaying = () => {
    if (!heroVideo || heroVideo.currentTime <= 0) return;
    heroHasPlayed = true;
    hero.classList.remove('hd-hero--video-fallback');
    hero.classList.add('hd-hero--video-playing');
  };

  const startHeroVideo = () => {
    if (!heroVideo || !heroVideo.paused) return;
    heroVideo.defaultMuted = true;
    heroVideo.muted = true;
    const playAttempt = heroVideo.play();
    playAttempt?.catch(showVideoFallback);
  };

  const recoverHeroVideo = () => {
    if (!heroVideo || document.visibilityState !== 'visible') return;
    if (videoRecoveryAttempted) {
      showVideoFallback();
      return;
    }

    videoRecoveryAttempted = true;
    heroVideo.load();
    heroVideo.addEventListener('canplay', startHeroVideo, { once: true });
  };

  const resumeHeroVideo = () => {
    if (!heroVideo || document.visibilityState !== 'visible') return;
    if (!heroHasPlayed) {
      startHeroVideo();
      return;
    }
    const resumeTime = heroVideo.currentTime;
    startHeroVideo();

    window.setTimeout(() => {
      const didAdvance = heroVideo.currentTime > resumeTime + 0.05;
      if (!didAdvance) recoverHeroVideo();
    }, 450);
  };

  if (heroVideo?.readyState >= 2) {
    startHeroVideo();
  } else {
    heroVideo?.addEventListener('canplay', startHeroVideo, { once: true });
  }
  window.addEventListener('pageshow', resumeHeroVideo);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') resumeHeroVideo();
  });
  heroVideo?.addEventListener('playing', markVideoPlaying);
  heroVideo?.addEventListener('timeupdate', markVideoPlaying, { once: true });
  heroVideo?.addEventListener('stalled', recoverHeroVideo);
  heroVideo?.addEventListener('error', showVideoFallback);

  let headerFrame;
  let solidHeaderThreshold = Math.max(80, hero.offsetHeight - 120);
  const updateHeader = () => {
    headerFrame = null;
    const isSolid = window.scrollY > solidHeaderThreshold;
    homeNav?.classList.toggle('hd-home-nav--solid', isSolid);
    standardHeader?.classList.toggle('hd-home-header--solid', isSolid);
  };
  const requestHeaderUpdate = () => {
    if (headerFrame) return;
    headerFrame = window.requestAnimationFrame(updateHeader);
  };
  const resizeHeader = () => {
    solidHeaderThreshold = Math.max(80, hero.offsetHeight - 120);
    requestHeaderUpdate();
  };

  updateHeader();
  window.addEventListener('scroll', requestHeaderUpdate, { passive: true });
  window.addEventListener('resize', resizeHeader, { passive: true });

  const shopMenu = homeNav?.querySelector('.hd-home-nav__shop-menu');
  if (shopMenu) {
    const shopSummary = shopMenu.querySelector('summary');
    let openTimer;
    let closeTimer;

    const cancelTimers = () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
    };

    shopMenu.addEventListener('mouseenter', () => {
      cancelTimers();
      openTimer = window.setTimeout(() => {
        shopMenu.open = true;
      }, 350);
    });

    shopMenu.addEventListener('mouseleave', () => {
      cancelTimers();
      closeTimer = window.setTimeout(() => {
        shopMenu.open = false;
      }, 450);
    });

    shopMenu.addEventListener('click', (event) => {
      if (event.target.closest('a')) shopMenu.open = false;
    });

    document.addEventListener('click', (event) => {
      if (!shopMenu.contains(event.target)) shopMenu.open = false;
    });

    shopMenu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !shopMenu.open) return;
      shopMenu.open = false;
      shopSummary?.focus();
    });
  }

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const reviewDetails = {
    '6c3d5016-a509-4825-904a-0537bd6792cf': {
      title: 'Backpack',
      text: 'I just received the backpack and it is beautiful, spacious and comfortable, just like in the photos. We have taken our first walk and the experience has been positive.',
      product: 'Puha Front Carry Pet Carrier',
    },
    '59f93f76-1640-4348-ac6b-a70262e162b7': {
      title: 'So far the best cat carrier we found',
      text: 'I tried taking this bag out this weekend and the process went smoothly. When he got tired, I put him in the bag and he enjoyed it very much.',
      product: 'Ccros Front Facing Pet Carrier',
    },
    '511edd17-4094-44af-83b4-beb19b97b117': {
      title: 'The bag is fine to carry',
      text: 'The quality of the stuff is very good. Cats need a bit of training and getting used to it; patience is needed and cats will love it soon.',
      product: 'Sling Tote Carrier',
    },
  };

  const enhanceProducts = () => {
    const collection = document.querySelector(".section[id*='featured_collection']");
    if (!collection) return;

    const cards = [...collection.querySelectorAll('.card-wrapper')];
    cards.forEach((card, index) => {
      card.querySelectorAll('.card__heading a').forEach((title) => {
        title.textContent = title.textContent.replace(/^\s*\(NEW\)\s*/i, '').trim();
      });

      card.querySelectorAll('.price-item').forEach((price) => {
        price.textContent = price.textContent.replace(/\s+USD\s*$/i, '').trim();
      });

      const media = card.querySelector('.card__inner');
      if (media && !media.querySelector('.hd-product-badge')) {
        media.append(createElement('span', 'hd-product-badge', 'New'));
      }

      const information = card.querySelector('.card-information');
      if (information && !information.querySelector('.hd-product-note')) {
        information.append(createElement('span', 'hd-product-note', 'New'));
      }
    });

    const viewAll = collection.querySelector('.collection__view-all a');
    if (viewAll) viewAll.textContent = 'Shop all';
  };

  enhanceProducts();

  const enhanceReviewCard = (card) => {
    if (card.dataset.hdEnhanced === 'true') return true;

    const text = card.querySelector('.jdgm-text');
    const stars = card.querySelector('.jdgm-stars');
    const reviewer = card.querySelector('.jdgm-reviewer-name');
    const product = card.querySelector('.jdgm-product-name');
    if (!text || !stars || !reviewer || !product) return false;

    const review = reviewDetails[card.dataset.reviewId];
    if (review) text.textContent = review.text;

    const activeStars = stars.querySelectorAll('.jdgm-star.jdgm--on').length;
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', `${activeStars || 5} out of 5 stars`);

    const overlay = createElement('div', 'hd-review-overlay');
    overlay.append(stars);
    overlay.append(createElement('h3', '', review?.title || product.textContent.trim()));
    overlay.append(text);

    const meta = createElement('div', 'hd-review-meta');
    meta.append(reviewer);
    meta.append(createElement('span', 'hd-review-verified', card.querySelector('.jdgm-reviewer-verified-icon') ? 'Verified buyer' : 'Customer review'));
    overlay.append(meta);
    overlay.append(createElement('span', 'hd-review-product', review?.product || product.textContent.trim()));
    card.append(overlay);
    card.dataset.hdEnhanced = 'true';
    return true;
  };

  const setupReviewCarousel = (widget) => {
    const track = widget.querySelector('.jdgm-videos-container');
    if (!track) return false;

    const hideClonedSlidesFromAssistiveTech = () => {
      track.querySelectorAll('.jdgm-card[data-clone-type]').forEach((card) => {
        card.setAttribute('aria-hidden', 'true');
        card.removeAttribute('role');
        card.removeAttribute('aria-roledescription');
        card.removeAttribute('aria-label');
        card.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((control) => {
          control.tabIndex = -1;
        });
      });
    };

    hideClonedSlidesFromAssistiveTech();
    const cloneObserver = new MutationObserver(hideClonedSlidesFromAssistiveTech);
    cloneObserver.observe(track, { childList: true, subtree: true });

    const seenReviewIds = new Set();
    const reviewCards = [...track.querySelectorAll('.jdgm-card:not([data-clone-type])')];
    const slides = reviewCards.filter((card) => {
      const reviewId = card.dataset.reviewId;
      const hasImage = Boolean(card.querySelector(':scope > img, .jdgm-media-card__image'));
      const hasReviewData = Boolean(
        card.querySelector('.jdgm-text')
        && card.querySelector('.jdgm-stars')
        && card.querySelector('.jdgm-reviewer-name')
        && card.querySelector('.jdgm-product-name')
      );

      if (!reviewId || seenReviewIds.has(reviewId) || !hasImage || !hasReviewData) return false;
      seenReviewIds.add(reviewId);
      return true;
    });

    reviewCards.forEach((card) => {
      card.classList.remove('hd-review-slide');
      card.setAttribute('aria-hidden', 'true');
    });

    slides.forEach((card, index) => {
      if (!enhanceReviewCard(card)) return;
      card.classList.add('hd-review-slide');
      card.removeAttribute('aria-hidden');
      card.setAttribute('role', 'group');
      card.setAttribute('aria-roledescription', 'slide');
      card.setAttribute('aria-label', `Customer review ${index + 1} of ${slides.length}`);
    });

    if (slides.length < 2) return false;

    track.setAttribute('role', 'region');
    track.setAttribute('aria-roledescription', 'carousel');
    track.setAttribute('aria-label', 'Customer photo reviews');
    track.tabIndex = 0;

    let navigation = widget.querySelector('.hd-review-carousel-nav');
    if (!navigation) {
      navigation = createElement('div', 'hd-review-carousel-nav');
      const previous = createElement('button', 'hd-review-carousel-button hd-review-carousel-button--previous');
      const next = createElement('button', 'hd-review-carousel-button hd-review-carousel-button--next');
      const status = createElement('span', 'hd-review-carousel-status');

      previous.type = 'button';
      previous.setAttribute('aria-label', 'Previous customer reviews');
      previous.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14.5 5-7 7 7 7"/></svg>';
      next.type = 'button';
      next.setAttribute('aria-label', 'Next customer reviews');
      next.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9.5 5 7 7-7 7"/></svg>';
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      navigation.append(previous, status, next);
      track.parentElement?.append(navigation);
    }

    const previous = navigation.querySelector('.hd-review-carousel-button--previous');
    const next = navigation.querySelector('.hd-review-carousel-button--next');
    const status = navigation.querySelector('.hd-review-carousel-status');

    const carouselMetrics = () => {
      const firstSlide = track.querySelector('.hd-review-slide');
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = (firstSlide?.getBoundingClientRect().width || track.clientWidth) + gap;
      const visibleCount = Math.max(1, Math.round((track.clientWidth + gap) / step));
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      return { step, visibleCount, maxScroll };
    };

    const updateCarouselState = () => {
      const { step, visibleCount, maxScroll } = carouselMetrics();
      const firstVisibleIndex = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / step)));
      const pageCount = Math.ceil(slides.length / visibleCount);
      const currentPage = Math.min(pageCount, Math.floor(firstVisibleIndex / visibleCount) + 1);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
      const statusText = `${currentPage} of ${pageCount}`;
      if (status.textContent !== statusText) status.textContent = statusText;
    };

    const moveCarousel = (direction) => {
      const { step, visibleCount, maxScroll } = carouselMetrics();
      const destination = Math.min(maxScroll, Math.max(0, track.scrollLeft + direction * step * visibleCount));
      track.scrollTo({
        left: destination,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    };

    if (navigation.dataset.hdBound !== 'true') {
      previous.addEventListener('click', () => moveCarousel(-1));
      next.addEventListener('click', () => moveCarousel(1));
      track.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        moveCarousel(event.key === 'ArrowLeft' ? -1 : 1);
      });
      let updateFrame;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(updateFrame);
        updateFrame = window.requestAnimationFrame(updateCarouselState);
      }, { passive: true });
      window.addEventListener('resize', updateCarouselState, { passive: true });
      navigation.dataset.hdBound = 'true';
    }

    updateCarouselState();
    track.dataset.hdCarouselReady = 'true';
    return slides.every((card) => card.dataset.hdEnhanced === 'true');
  };

  const enhanceJudgeMe = () => {
    const widget = document.querySelector('.jdgm-cards-carousel');
    const header = widget?.querySelector('.jdgm-header');
    if (!widget || !header) return false;

    if (header.dataset.hdEnhanced !== 'true') {
      const title = header.querySelector('.jdgm-title')?.textContent.trim() || 'Real pets are the best proof.';
      const ratingText = header.querySelector('.jdgm-rating-text')?.textContent || '';
      const rating = ratingText.match(/[0-9]+(?:\.[0-9]+)?/)?.[0] || '4.86';
      const count = header.querySelector('.jdgm-reviews-count')?.textContent.trim() || '';

      const summary = createElement('div', 'hd-review-summary');
      summary.append(createElement('p', 'hd-eyebrow', 'Customer reviews'));
      summary.append(createElement('span', 'hd-review-number', rating));
      const stars = createElement('div', 'hd-review-stars', '★★★★★');
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `${rating} out of 5 stars`);
      summary.append(stars);
      summary.append(createElement('p', 'hd-review-note', `Based on ${count} customer reviews`));

      const intro = createElement('div', 'hd-review-intro');
      intro.append(createElement('h2', '', title));
      intro.append(createElement('p', '', 'See how pets and their people use HiDREAM every day.'));
      const link = createElement('a', 'hd-text-link', 'Read customer reviews →');
      link.href = hero.dataset.customerReviewsUrl || '/pages/customer-reviews';
      intro.append(link);

      header.id = 'hidream-customer-reviews';
      header.replaceChildren(summary, intro);
      header.dataset.hdEnhanced = 'true';
    }

    return setupReviewCarousel(widget);
  };

  if (!enhanceJudgeMe()) {
    const reviewObserver = new MutationObserver(() => {
      if (enhanceJudgeMe()) reviewObserver.disconnect();
    });
    reviewObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => reviewObserver.disconnect(), 15000);
  }

  document.addEventListener('click', (event) => {
    const hotspot = event.target.closest('.hd-hotspot');
    const openHotspots = document.querySelectorAll('.hd-hotspot[aria-expanded="true"]');

    if (!hotspot) {
      openHotspots.forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
        const card = document.getElementById(button.getAttribute('aria-controls'));
        if (card) card.hidden = true;
      });
      return;
    }

    event.stopPropagation();
    const willOpen = hotspot.getAttribute('aria-expanded') !== 'true';
    document.querySelectorAll('.hd-hotspot').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
      const card = document.getElementById(button.getAttribute('aria-controls'));
      if (card) card.hidden = true;
    });

    hotspot.setAttribute('aria-expanded', String(willOpen));
    const card = document.getElementById(hotspot.getAttribute('aria-controls'));
    if (card) card.hidden = !willOpen;
  });
})();
